import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SmsSettingsResponse } from '../models/responses/sms-settings-response';
import { environment } from '../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class SmsSettingsService {

  constructor(private httpClient:HttpClient) { }

  createSmsSettings(smsSettings:SmsSettingsResponse){
    return this.httpClient.post<SmsSettingsResponse>(`${environment.smsSettingsUrl}`,smsSettings);
  }
  updateSmsSettings(smsSettings:SmsSettingsResponse){
    return this.httpClient.put<SmsSettingsResponse>(`${environment.smsSettingsUrl}`,smsSettings);
  }
  deleteSmsSettigns(id:number){
    return this.httpClient.delete<SmsSettingsResponse>(`${environment.smsSettingsUrl}/${id}`);
  }
}
